export default "__VITE_ASSET__009bb9d7__"